import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

// Services
import { LanguageService } from 'app/_services/language.service';

// Models
import { Client } from '../../models/client';
import { NavLink } from '../../models/nav-link';

// App config
import { ConfigData } from './../../app.config';
import { PERMISSION_CODES } from 'app/constants/permission-codes';
import { AuthenticationService } from 'app/_services/authentication.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'fury-client-detail',
  templateUrl: './client-detail.component.html',
  styleUrls: ['./client-detail.component.scss']
})
export class ClientDetailComponent implements OnInit, OnDestroy {
  navLinks: NavLink[] = [
  ];

  currentClient: Client = {
    idclient: '',
    description: ''
  };

  selectedRoute: string;

  private destroy$ = new Subject();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public languageService: LanguageService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.currentClient.idclient = this.route.snapshot.paramMap.get('id');
    this.buildTabs();

    this.languageService.languageChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe((_) => this.buildTabs());
  }

  private buildTabs(): void {
    this.navLinks = [];
    this.selectedRoute = this.router.url.split('/')[3] || null;

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CLIENT_TABS.NAVIGAZIONE_DINAMICA) && !ConfigData.cloudSearch) {
      this.navLinks.push({
        path: 'filters',
        label: this.languageService.getLabel(
          'client-Details.NavigazioneDinamica'
        ),
        visible: true,
        disabled: false
      });

      this.selectedRoute = this.selectedRoute || 'filters';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CLIENT_TABS.KEYMATCH)) {
      this.navLinks.push({
        path: 'keymatch',
        label: this.languageService.getLabel('client-Details.Keymatch'),
        visible: true,
        disabled: false
      });

      this.selectedRoute = this.selectedRoute || 'keymatch';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CLIENT_TABS.ONEBOX)) {
      this.navLinks.push(
        {
          path: 'onebox',
          label: this.languageService.getLabel('client-Details.Onebox'),
          visible: true,
          disabled: false
        }
      );

      this.selectedRoute = this.selectedRoute || 'onebox';

    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CLIENT_TABS.QUERY_CORRELATE)) {
      this.navLinks.push({
        path: 'related-query',
        label: this.languageService.getLabel('client-Details.QueryCorrelate'),
        visible: true,
        disabled: false
      });

      this.selectedRoute = this.selectedRoute || 'related-query';

    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CLIENT_TABS.ESCLUDI_URL)) {
      this.navLinks.push({
        path: 'exclude-url',
        label: this.languageService.getLabel('client-Details.EscludiURL'),
        visible: true,
        disabled: false
      });

      this.selectedRoute = this.selectedRoute || 'exclude-url';

    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CLIENT_TABS.ASSOCIAZIONE_TEMPLATE_ELASTIC)) {
      this.navLinks.push({
        path: 'template-elastic',
        label: this.languageService.getLabel(
          'client-Details.AssociazioneTemplate'
        ),
        visible: true,
        disabled: false
      });

      this.selectedRoute = this.selectedRoute || 'template-elastic';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CLIENT_TABS.POLICY_DIFF_RISULTATI)) {
      this.navLinks.push({
        path: 'search-diff',
        label: this.languageService.getLabel('client-Details.Policy'),
        visible: true,
        disabled: false
      });

      this.selectedRoute = this.selectedRoute || 'search-diff';
    }


    if (this.selectedRoute) {
      this.router.navigate(['client-detail', this.currentClient.idclient, this.selectedRoute]);
    }

  }


  back() {
    this.router.navigate(['/clients']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
